export const baseUrl = {
    'url': process.env.REACT_APP_TXE_BASE_URL,
}